import { jsx } from "react/jsx-runtime";
import Box from "@mui/material/Box/index.js";
import { getRootStyles } from "./icon-button.styles.js";
const IconButton = ({ onClick, hoverColor, children }) => {
  return /* @__PURE__ */ jsx(Box, { sx: getRootStyles({ hoverColor }), onClick, children });
};
export {
  IconButton
};
